var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"switch-v2 w-9 h-5 p-0.5 m-0 flex items-center shrink-0 rounded-full border-0 transition-colors",class:[
    _vm.value ? 'bg-green-500' : 'bg-gray-200',
    _vm.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
  ],attrs:{"type":"button","role":"switch","aria-checked":_vm.value ? 'true' : 'false',"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('span',{staticClass:"block w-4 h-4 rounded-full bg-white transition-transform",class:_vm.value ? 'ltr:translate-x-4 rtl:-translate-x-4' : ''})])
}
var staticRenderFns = []

export { render, staticRenderFns }